import { requestService as api } from "./Request.service";

const API_URL = {
  ME: `/permission/me.php`,
  LIST: `/permission/get-permission.php`,
  MANAGE: `/permission/manage.php`,
  ROLE_USERS: `/permission/role-users.php`,
};

const PermissionService = () => {
  const me = (config = {}) => api.get(API_URL.ME, { ignoreLoading: true, ...config });
  const list = (config = {}) => api.get(API_URL.LIST, config);

  const saveMatrix = (matrix) => api.put(API_URL.MANAGE, { matrix });
  const createRole = (header) => api.post(API_URL.MANAGE, { header });
  const updateRole = (header) => api.patch(API_URL.MANAGE, { header });
  const deleteRole = (code) => api.delete(`${API_URL.MANAGE}?code=${encodeURIComponent(code)}`);
  const roleUsers = (code) => api.get(`${API_URL.ROLE_USERS}?code=${encodeURIComponent(code)}`);

  return { me, list, saveMatrix, createRole, updateRole, deleteRole, roleUsers };
};

export default PermissionService;
